import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ExerciseTaskModuleModule } from '@app/page-modules/exercise-task-module/exercise-task-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './../@shared/shared.module';
import { MaterialModule } from './../material.module';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { QuestionDialogComponent } from './question-dialog.ts/question-dialog.component';
import { QuestionHintDialogComponent } from './question-hint-dialog/question-hint-dialog.component';
import { TrialExamResultDialogComponent } from './trial-exam-result-dialog.ts/trial-exam-result-dialog.component';
import { VideoQuestionSetDialogComponent } from './video-question-set-dialog.ts/video-question-set-dialog.component';
import { ResetPasswordDialogComponent } from './reset-password-dialog/reset-password-dialog.component';
import { ProfileConfirmationDialogModule } from './profile-confirmation-dialog.ts/profile-confirmation-dialog.module';
import { CertificateFieldsDialogComponent } from './certificate-fields-dialog/certificate-fields-dialog.component';

@NgModule({
  imports: [
    SharedModule,
    MatDialogModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    CommonModule,
    ExerciseTaskModuleModule,
    ProfileConfirmationDialogModule,
  ],
  declarations: [
    AlertDialogComponent,
    QuestionDialogComponent,
    TrialExamResultDialogComponent,
    VideoQuestionSetDialogComponent,
    QuestionHintDialogComponent,
    ResetPasswordDialogComponent,
    CertificateFieldsDialogComponent,
  ],
  providers: [],
})
export class DialogsModule {}
